module.exports = __webpack_public_path__ + "static/img/useTutorial-bg1.1784115679763.png";